import React from "react";
import { useLocation } from "react-router-dom";
import { isActiveItem } from "./useNavItems";

/* Greys and the accent tint come from the theme tokens rather than fixed
   Tailwind palette steps, so the pills survive the dark theme. */
export function NavbarItem({ item, variant = "desktop", onClick }) {
    const { label, icon: Icon, href, comingSoon } = item;
    // Read through the router so the highlight follows in-app navigation.
    const { pathname } = useLocation();
    const isActive = !comingSoon && isActiveItem(href, pathname);

    const base = `
        flex items-center gap-2 rounded-lg font-medium
        transition-colors duration-150 ease-in-out whitespace-nowrap
        ${variant === "mobile" ? "w-full px-3 py-3 text-base" : "px-3 py-2 text-sm"}
    `;

    if (comingSoon) {
        return (
            <span
                title={`${label} — coming soon`}
                className={`${base} cursor-not-allowed text-usdx-ink-subtle/70`}
            >
                <Icon className="h-5 w-5 shrink-0" />
                {label}
                <span className="ml-1 rounded-full bg-usdx-surface-sunken px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-usdx-ink-subtle">
                    Soon
                </span>
            </span>
        );
    }

    return (
        <a
            href={href}
            onClick={onClick}
            className={`${base} ${
                isActive
                    ? "bg-usdx-accent/10 font-bold text-usdx-accent"
                    : "text-usdx-ink-muted hover:bg-usdx-surface-sunken hover:text-usdx-ink"
            }`}
        >
            <Icon className="h-5 w-5 shrink-0" />
            {label}
        </a>
    );
}

export default NavbarItem;
